import React from 'react';
import {observer} from 'mobx-react';
import {CheckoutInputElement} from '../../../inputs/checkoutInputs';
import store from '../../../../s';

type Props = {
    address: IAddress;
};

const FormMultilineShipments = observer((props: Props) => {
    const {firstName, lastName, address1, address2, city, state, postalCode, country, isBusinessAddress} = props.address;

    return (
        <div className="form-multiline-shipments">
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={firstName}
                label="First Name"
                required={true}
                ariaLabel="Shipping First Name"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={lastName}
                label="Last Name"
                required={true}
                ariaLabel="Shipping Last Name"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={address1}
                required={true}
                places={true}
                ariaLabel="Shipping Address Line 1"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={address2}
                required={false}
                ariaLabel="Shipping Address Line 2"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={city}
                required={true}
                ariaLabel="Shipping City"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={state}
                label="State"
                required={true}
                ariaLabel="Shipping State"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={postalCode}
                type="text"
                required={true}
                hideSpinner={true}
                ariaLabel="Shipping Postal Code"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={country}
                label="Country"
                required={true}
                ariaLabel="Shipping Country"
            />
            <div className="col-12 col-md-6 text-left mt-1">
                <label className="radio-container">
                    <input
                        type="checkbox"
                        aria-label="Business Address"
                        className="radio radio-sm"
                        name="shipping-business-address"
                        value={1}
                        checked={isBusinessAddress}
                        onChange={() => (props.address.isBusinessAddress = !props.address.isBusinessAddress)}
                    />
                    <span className="radio-label">Business Address</span>
                </label>
            </div>
        </div>
    );
});

export default FormMultilineShipments;
